module.exports = __webpack_public_path__ + "img/evolution.8b553a6b.svg";